import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToasterService} from './toaster.service';

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {

  constructor(private http: HttpClient, private toasterService: ToasterService,) {
  }

  ensureCorrectExtension(url: string, fileName: string): string {
    const getFileExtension = (filePath: string): string => {
      const match = filePath.match(/\.([^.]+)$/);
      return match ? match[1] : '';
    };

    const urlExtension = getFileExtension(url);
    const fileNameExtension = getFileExtension(fileName);

    if (fileNameExtension !== urlExtension) {
      fileName = fileName.replace(/\.[^/.]+$/, '') + '.' + urlExtension;
    }

    return encodeURIComponent(fileName.replace(/ /g, '_'));
  }

  downloadFile(url: string, fileName: string): void {
    // ensure the file name has the correct extension
    const finalName = this.ensureCorrectExtension(url, fileName);

    this.http.get(url, {responseType: 'blob'}).subscribe(
      (response: Blob) => {
        const data = window.URL.createObjectURL(response);
        const a = document.createElement('a');
        a.href = data;
        a.target = '_blank';
        a.download = finalName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      (_error) => {
        this.toasterService.showError(
          'File Doesnot Exist',
          'Error'
        );
      }
    );
  }

}
